import React, {Component} from 'react';
import {I18n} from '../i18n/I18n';

export class BadRequest extends Component {
  render() {
    return <I18n t='Server error' />;
  }
}
